/*
Academy guide categories should follow enum from the API.
These are placeholders until we have all categories defined.
**/
export const ACADEMY_GUIDE_CATEGORIES = [
  { key: 'all', label_translation_key: 'guide_category_all' },
  { key: 'basics', label_translation_key: 'guide_category_basics' },
  { key: 'skade', label_translation_key: 'guide_category_skade' },
  { key: 'understand', label_translation_key: 'guide_category_understand' },
  { key: 'budget', label_translation_key: 'guide_category_budget' },
];

export const ACADEMY_GUIDE_GROUP_IDS = {
  PORTFOLIO: '441142cb-377e-4988-b191-c574b6f152fe',
  SKADE_METHOD: 'c7ec05e5-7189-46c1-a171-64796a3d5e66',
};
